export type SeriesId = "robot" | "trash-punks" | "goth-girls";

export type Series = {
  id: SeriesId;
  name: string;
  image: string;
  vibe: string;
  characters: string[];
  bodyColors: string;
};

export const series: Series[] = [
  {
    id: "robot",
    name: "Robot Series",
    image: "https://cdn.magicpatterns.com/uploads/74Q8ATNqUKeESkqjTJAL82/ChatGPT_Image_Sep_24,_2026,_05_17_00_PM_(1).png",
    vibe: "Clean, techy, and gender-neutral. The widest appeal of the three.",
    characters: ["Frost", "Ember", "Moss"],
    bodyColors: "White · Black · Sage",
  },
  {
    id: "trash-punks",
    name: "Trash Punks",
    image: "https://cdn.magicpatterns.com/uploads/33ZWC2SmJSxfTFHKKxzPPy/ChatGPT_Image_Sep_24,_2026,_05_17_00_PM_(2).png",
    vibe: "Loud neon graffiti characters with attitude. Built to grab attention on a counter.",
    characters: ["Panda", "Zombie", "Kitty"],
    bodyColors: "White · Neon lime · Hot pink",
  },
  {
    id: "goth-girls",
    name: "Goth Girls",
    image: "https://cdn.magicpatterns.com/uploads/cE8gNTS5mU5tsB1Tv9wBnk/ChatGPT_Image_Sep_24,_2026,_05_16_50_PM.png",
    vibe: "Soft pastel goth, anime style. A strong collectible and gift angle.",
    characters: ["Noir", "Rose", "Sage"],
    bodyColors: "Black · Dusty pink · Mint",
  },
];
